<h1 class="matp-page-title">設定テンプレート一覧</h1>

<!-- 設定テンプレート一覧 -->
<mat-card class="matp-card">
  <app-asset-type-list-table
    [isDisabled]="isDisabled"
    [assetTypeList]="assetTypeList"
    [deviceTypes]="deviceTypes"
    (created)="openAssetTypeEditDialog()"
    (updated)="openAssetTypeEditDialog($event)"
    (deleted)="deletedAssetType($event)"
    (copied)="copiedAssetType($event)"
  ></app-asset-type-list-table>
</mat-card>
